/* ==========================================================
   TEEINBLUE — SHIPPING PROTECTION
   VISUAL STATE CONTROLLER
   ========================================================== */

(function () {

  const SELECTOR = '.shipping-protection';


  /* --------------------------------------------------------
     Find the clickable option label
     -------------------------------------------------------- */

  function getOptionLabel(container) {
    if (!container) return null;

    const labels = container.querySelectorAll('label');

    if (!labels.length) return null;

    return labels[0];
  }


  /* --------------------------------------------------------
     Make price independently styleable
     Example:
     (+ $2.99)
     -------------------------------------------------------- */

  function stylePrice(container) {

    const label = getOptionLabel(container);

    if (!label) return;

    /* Already processed */
    if (label.querySelector('.shipping-protection-price')) {
      return;
    }

    const walker = document.createTreeWalker(
      label,
      NodeFilter.SHOW_TEXT,
      null
    );

    const textNodes = [];

    while (walker.nextNode()) {
      textNodes.push(walker.currentNode);
    }

    textNodes.forEach(function (node) {

      const text = node.nodeValue;

      if (!text) return;

      /*
        Matches examples such as:
        (+ $2.99)
        (+$2.99)
        (+ $5.00)
        (+$5.00)
      */

      const match = text.match(
        /(\(\s*\+\s*[$€£]?\s*\d+(?:[.,]\d{1,2})?\s*\))/
      );

      if (!match) return;

      const before = text.slice(0, match.index);
      const price = match[1];
      const after = text.slice(
        match.index + match[1].length
      );

      const fragment = document.createDocumentFragment();

      if (before) {
        fragment.appendChild(
          document.createTextNode(before)
        );
      }

      const span = document.createElement('span');

      span.className =
        'shipping-protection-price';

      span.textContent = price;

      fragment.appendChild(span);

      if (after) {
        fragment.appendChild(
          document.createTextNode(after)
        );
      }

      node.parentNode.replaceChild(
        fragment,
        node
      );
    });
  }


  /* --------------------------------------------------------
     Prepare newly-rendered Teeinblue option
     -------------------------------------------------------- */

  function prepareContainer(container) {

    if (!container) return;

    stylePrice(container);

    /*
      Shipping Protection is optional and should initially
      display OFF.

      Teeinblue remains responsible for the actual addon
      selection and charge.
    */

    if (
      !container.hasAttribute(
        'data-protection-visual-ready'
      )
    ) {

      container.classList.remove(
        'is-protection-selected'
      );

      container.setAttribute(
        'data-protection-visual-ready',
        'true'
      );
    }
  }


  /* --------------------------------------------------------
     Prepare all existing options
     -------------------------------------------------------- */

  function prepareAll() {

    document
      .querySelectorAll(SELECTOR)
      .forEach(prepareContainer);
  }


  /* --------------------------------------------------------
     Toggle visual state from ONE physical click/tap.

     pointerup is intentionally used rather than relying
     on input:checked because Teeinblue manages the addon
     state internally.
     -------------------------------------------------------- */

  document.addEventListener(
    'pointerup',
    function (event) {

      const container =
        event.target.closest(SELECTOR);

      if (!container) return;


      const label = getOptionLabel(container);

      if (!label) return;


      /*
        Only toggle when the customer interacts with
        the actual option row / selector.
      */

      const clickedLabel =
        event.target.closest('label');

      const clickedInput =
        event.target.matches(
          'input[type="checkbox"], input[type="radio"]'
        );

      if (
        clickedLabel !== label &&
        !clickedInput
      ) {
        return;
      }


      /*
        Allow Teeinblue's own event handler to run first.
        Then mirror that user action visually.
      */

      window.setTimeout(
        function () {

          container.classList.toggle(
            'is-protection-selected'
          );

        },
        30
      );

    },
    true
  );


  /* --------------------------------------------------------
     Keyboard support
     -------------------------------------------------------- */

  document.addEventListener(
    'keydown',
    function (event) {

      if (
        event.key !== 'Enter' &&
        event.key !== ' '
      ) {
        return;
      }

      const container =
        event.target.closest(SELECTOR);

      if (!container) return;

      window.setTimeout(
        function () {

          container.classList.toggle(
            'is-protection-selected'
          );

        },
        30
      );

    },
    true
  );


  /* --------------------------------------------------------
     Teeinblue can rebuild the personalization form after
     uploads/options change.

     Watch for newly-rendered elements and prepare them.
     -------------------------------------------------------- */

  const observer =
    new MutationObserver(function (mutations) {

      let shouldRefresh = false;

      mutations.forEach(function (mutation) {

        if (
          mutation.addedNodes &&
          mutation.addedNodes.length
        ) {
          shouldRefresh = true;
        }

      });

      if (shouldRefresh) {
        prepareAll();
      }

    });


  /* --------------------------------------------------------
     Start
     -------------------------------------------------------- */

  function init() {

    prepareAll();

    observer.observe(
      document.body,
      {
        childList: true,
        subtree: true
      }
    );
  }


  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      init
    );

  } else {

    init();

  }

})();